import { render, staticRenderFns } from "./ButtonView.vue?vue&type=template&id=ec57f80e&scoped=true&"
import script from "./ButtonView.vue?vue&type=script&lang=js&"
export * from "./ButtonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec57f80e",
  null
  
)

export default component.exports